export default __webpack_public_path__ + "static/media/justin-davis.645a62ff.png";